<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="row">
            <div class="col-12 m-1 text-right">
              <button class="btn btn-primary mr-2 " @click="saveWWR">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-header">
            <h3 class="card-title">Who We Are</h3>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <div class="col-12 mb-2">
                <Editor
                    :api-key="tinykey"
                    v-model="form.Who"
                    :init="{plugins: 'lists link image table code help wordcount'}"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'whoWeAre',
  data() {
    return {
      tinykey: process.env.VUE_APP_TINYKEY,
      form: {
        Who: '',
      }
    };
  },
  components: {
    Editor
  },
  methods:{
    saveWWR() {
      this.$store.dispatch('product/updateWWRData', this.form)
    }
  },
  mounted() {
    this.$store.dispatch('product/settingsData').then(rez => {
      let who = rez.find(obj => obj.name === "who_we_are");
      this.form.Who = who.data
      console.log('setting data',rez)
    })
  }
}
</script>

<style scoped>

</style>